import { _isNotEmpty } from '@/littledash.ts';
import { sortDescByDateStrProperty } from '@/utils/array.utils';
import ConsumptionList from '@/components/Workflow/Show/Views/Consumption/ConsumptionList.tsx';
import ConsumptionGraph from '@/components/Workflow/Show/Views/Consumption/ConsumptionGraph.tsx';
import { ConsumptionMetric, CageConsumptionMetricApiId } from '@/model/Consumption.model.ts';
import { FC } from 'react';
import { WorkflowNoCageDataCard } from '@/components/Workflow/Show/Views/Consumption/WorkflowNoCageData.tsx';
import { EditConsumptionRequest } from '@/components/Workflow/Show/WorkflowConsumption.tsx';
import { DeleteConsumptionRequest } from './ConsumptionActions.tsx';

interface ConsumptionMeasurementsProps {
  cageConsumptionData: Array<ConsumptionMetric>;
  onExcludeClick: (consumptionMetricApiId: CageConsumptionMetricApiId) => void;
  onEditClick: (consumptionMetricApiId: CageConsumptionMetricApiId, request: EditConsumptionRequest) => void;
  onDeleteClick: (consumptionMetricApiId: CageConsumptionMetricApiId, request: DeleteConsumptionRequest) => void;
}

const ConsumptionMeasurements: FC<ConsumptionMeasurementsProps> = ({
  cageConsumptionData,
  onExcludeClick,
  onEditClick,
  onDeleteClick,
}) => {
  const orderedMeasurements = cageConsumptionData.sort(sortDescByDateStrProperty('recorded_at'));
  const filteredMeasurements = orderedMeasurements.filter((m: ConsumptionMetric) => m.consumed !== null);

  return _isNotEmpty(filteredMeasurements) ? (
    <>
      <div className="mb4 ph3">
        <ConsumptionGraph measurements={filteredMeasurements} />
      </div>
      <div className="bt bb b--moon-gray" data-test-key="measurements-list">
        <ConsumptionList
          measurements={orderedMeasurements}
          onExcludeClick={onExcludeClick}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
        />
      </div>
    </>
  ) : (
    <>
      {WorkflowNoCageDataCard}
      {_isNotEmpty(orderedMeasurements) && (
        <div className="bt bb b--moon-gray">
          <ConsumptionList
            measurements={orderedMeasurements}
            onExcludeClick={onExcludeClick}
            onEditClick={onEditClick}
            onDeleteClick={onDeleteClick}
          />
        </div>
      )}
    </>
  );
};

export default ConsumptionMeasurements;
